import { shiftBriefingQueryKeys as e } from "./useShiftBriefingQueryKeys.mjs";
import { aiApi as t } from "@maat/api-ai";
import { useMutation as n, useQueryClient as r } from "@maat/store-hooks";
//#region src/shiftBriefing/useRegenerateShiftBriefingMutation.ts
var i = () => {
	let i = r();
	return n({
		retry: !1,
		mutationFn: ({ propertyId: e, date: n }) => t.getShiftBriefing({
			property_id: e,
			...n ? { date: n } : {},
			regenerate: !0
		}),
		onSuccess: (t, { propertyId: n, date: r }) => i.setQueryData(e.briefing(n, r), t)
	});
};
//#endregion
export { i as useRegenerateShiftBriefingMutation };
